<template>
  <div class="content">
    <!-- 修复：为标题栏添加定位，确保z-index生效 -->
    <div class="crowd-title">
      <van-icon
        name="arrow-left"
        @click.stop="onClickLeft"
        size="20"
        color="#ffffff"
      />
      <p class="f-w" style="font-size: var(--vk-fs-md)">
        {{ $lang.common_txt319 }}
      </p>
      <p @click="gotoRecord">{{ $lang.common_txt256 }}</p>
    </div>
    <div class="Crowdfunding">
      <div>
        <div class="d-flex" style="padding: 10px 30px">
          <img src="../../assets/img/otgame/gantanhao.png" />
          <p class="m-l-10" style="color: #ffe519; line-height: 18px">
            {{ $lang.common_txt320 }}
          </p>
        </div>

        <!-- 旋转背景图容器 - 放在最底层 -->
        <div class="crowd_rotate_img">
          <img
            src="../../assets/img/otgame/pinduoduo_7.png"
            width="100%"
            style="max-height: 460px"
          />
        </div>

        <!-- 大转盘核心区域 - 覆盖在背景图上方 -->
        <div class="turntable-wrapper">
          <div class="lettey-bg">
            <!-- 动态绑定背景图片样式 -->
            <div
              class="turntable-bg-s"
              :style="{
                background: `url(${bgImages[currentBgIndex]}) no-repeat`,
                transition: 'background 0.3s ease'
              }"
            ></div>

            <div class="container">
              <!-- 转盘容器 -->
              <div
                class="turntable"
                :style="{ transform: `rotate(${currentAngle}deg)` }"
              ></div>
              <!-- 操作按钮 -->
              <button
                class="pointer"
                :disabled="isSpinning"
                @click="startRotation"
              >
                {{ $lang.LuckyRoulette_txt5 }}
                <span style="color: #ffcd28">{{ drawCount }}</span>
                {{ $lang.LuckyRoulette_txt6 }}
              </button>
              <!-- <div v-if="isShareBtn" class="triangle"></div>
              <div v-if="isShareBtn" class="btn-share" style="color: #ffffff">
                {{ $lang.LuckyRoulette_txt7 }}
                <p
                  class="btn-share--b"
                  style="color: white"
                  @click="shareContent"
                >
                  <img
                    src="../../assets/img/lucky_jackpot/img_share.png"
                    width="15px"
                    class="m-r-10"
                  />{{ $lang.LuckyRoulette_txt8 }}
                </p>
                <p>
                  {{ $lang.LuckyRoulette_txt9 }}
                  <span class="info-color"></span>
                  {{ $lang.LuckyRoulette_txt10 }}
                </p>
                <img
                  @click="toggleRotation"
                  src="../../assets/img/common/home_top_refresh.png"
                  style="
                    background: #dd2647;
                    border-radius: 50%;
                    width: 17px;
                    padding: 2px;
                  "
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex m-t-20" style="justify-content: center">
        <img src="../../assets/img/otgame/pdd_shalou1.png" width="20" />
        <!-- 修改：在这里显示倒计时 -->
        <span class="f-t-15 m-l-5" style="color: #b1b0cd">
          {{ $lang.common_txt321 }}
        </span>
        <span style="color: #f3e514; font-size: var(--vk-fs-lg); margin-left: 5px">{{
          countdown
        }}</span>
      </div>
      <div class="crowdlist" style="padding: 10px">
        <div class="scroll_invites d-flex" style="justify-content: center">
          <img src="../../assets/img/otgame/pdd_xian_L.png" width="33%" />
          <span style="margin: 0 10px">{{ $lang.common_txt322 }}</span>
          <img src="../../assets/img/otgame/pdd_xian_R.png" width="33%" />
        </div>
        <div class="scroll_ranking">
          <div class="scroll_ranking_title d-flex-s">
            <p
              v-for="(item, index) in [
                $lang.common_txt323,
                $lang.common_txt324,
                $lang.common_txt325
              ]"
              :key="index"
            >
              {{ item }}
            </p>
          </div>
          <div class="scroll_ranking_sroll">
            <div
              class="d-flex-s m-b-10"
              style="padding: 5px 43px 5px 30px"
              v-for="(item, index) in myRecordList"
              :key="index"
            >
              <span>{{ index + 1 }}</span>
              <span>
                {{ formatRecordDate(item.drawDate) }}</span
              >
              <span>{{ item.bonusSum }}</span>
            </div>
            <div
              v-if="myRecordList.length === 0"
              style="text-align: center; margin-top: 20px"
            >
              {{ $lang.common_txt326 }}
            </div>
          </div>
        </div>

        <div
          class="d-flex m-t-20"
          style="justify-content: center; color: #4f81db"
        >
          <span>-------------</span>
          <span class="m-l-5 m-r-5 f-t-15"> {{ $lang.common_txt327 }} </span>
          <span>-------------</span>
        </div>
        <div
          style="padding: 10px; color: #6b6f88"
          v-html="$lang.LuckyRoulette_txt11"
        ></div>
      </div>
    </div>
    <login v-model="showPopup" overlay></login>
  </div>
</template>

<script>
import {
  GetLuckyRoulette,
  LuckyRoulette,
  GetLuckyRouletteRecord
} from '@/api/common'
import {
  failMessage as responseFailMessage,
  hasRewardIssueProof,
  hasServerProvenEmptyRead,
  hasUnavailableMarker,
  isNeedLogin,
  isOkResponse,
  isRouletteSuccess as rewardRouletteSuccess,
  responseContent
} from '@/views/details/activity/rewardApi'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { safeInviteUrl } from '@/components/share/shareSafety'

const CROWDFUNDING_UNAVAILABLE_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
const CROWDFUNDING_BLOCKED_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
const CROWDFUNDING_READONLY_MESSAGE = 'This feature is temporarily unavailable. Please try again later.'
const CROWDFUNDING_LOGIN_MESSAGE = 'Please log in to continue.'
const SHARE_FAILED_MESSAGE = 'Sharing did not complete. Please try again or copy the link to share.'
const SHARE_UNSUPPORTED_MESSAGE = 'Your browser does not support sharing. Please copy the link to share.'
const SHARE_CANCELLED_NAMES = ['aborterror', 'notallowederror']

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}
const GENERIC_SHARE_FAILURE_RE = /^(request failed|network error|sharing failed|share failed|\[object object\])$/i
const TECHNICAL_FAILURE_RE = /(技术错误|技术异常|technical[ _-]?(error|exception)|request failed|axios(?:error)?|\b(typeerror|referenceerror|syntaxerror|rangeerror|urierror)\b|\b(econn[a-z_]*|enotfound|etimedout|eai_again|socket hang up)\b|\b(java\.|sql(?:exception)?|select\s+.+\s+from|insert\s+into|update\s+.+\s+set|delete\s+from)\b|\bat\s+[\w.$<>]+(?:\s|\())/i

function safeString(value) {
  return String(value == null ? '' : value).trim()
}

function shareFailureMessage(error) {
  const errorName = safeString(error && error.name).toLowerCase()
  if (SHARE_CANCELLED_NAMES.includes(errorName)) {
    return ''
  }
  const message = safeString(error && error.message)
  return message && !GENERIC_SHARE_FAILURE_RE.test(message) ? message : SHARE_FAILED_MESSAGE
}

function getLocationOrigin() {
  try {
    return typeof window !== 'undefined' && window && window.location ? (window.location.origin || '') : ''
  } catch (e) {
    return ''
  }
}

function buildShareUrl(storage) {
  try {
    return safeInviteUrl(
      getLocationOrigin(),
      safeGetStorageItem(storage, 'country'),
      safeGetStorageItem(storage, 'shareCode')
    ) || ''
  } catch (e) {
    return ''
  }
}

function getNavigator() {
  try {
    return typeof navigator === 'undefined' ? null : navigator
  } catch (e) {
    return null
  }
}

function getNativeShare() {
  const nav = getNavigator()
  try {
    return nav && typeof nav.share === 'function' ? { nav, share: nav.share } : null
  } catch (e) {
    return null
  }
}

function canUseNativeShare() {
  try {
    const nav = getNavigator()
    return Boolean(nav && typeof nav.share === 'function')
  } catch (e) {
    return false
  }
}

function callNativeShare(nativeShare, payload) {
  try {
    return nativeShare && nativeShare.share.call(nativeShare.nav, payload)
  } catch (e) {
    return Promise.reject(e)
  }
}

function safeToast(vm, payload) {
  if (vm && typeof vm.$toast === 'function') vm.$toast(payload)
}

function isTechnicalFailureMessage(value) {
  return TECHNICAL_FAILURE_RE.test(safeString(value))
}

function safeCrowdfundingFallback(fallback, defaultMessage = CROWDFUNDING_UNAVAILABLE_MESSAGE) {
  const message = safeString(fallback)
  return !message || message === 'Request failed' || isTechnicalFailureMessage(message)
    ? defaultMessage
    : message
}

export default {
  name: 'Crowdfunding',
  components: {},
  data() {
    return {
      myRecordList: [],
      showPopup: false,
      // 大转盘相关数据
      isShareBtn: false,
      bonusSum: 0,
      drawCount: 0,
      currentAngle: 0, // 当前旋转角度
      isSpinning: false, // 是否正在旋转
      prizeCount: 6, // 奖品总数（根据实际修改）
      getBonusSum: 0,
      rouletteAvailable: false,
      // 背景图片切换相关
      bgImages: [
        require('@/assets/img/otgame/pinduoduo_11.png'),
        require('@/assets/img/otgame/pinduoduo_12.png')
      ],
      currentBgIndex: 0, // 当前显示的图片索引
      bgSwitchTimer: null, // 定时器标识
      // 新增：倒计时相关数据
      countdown: '00:00:00', // 初始化倒计时显示
      timer2: null // 倒计时定时器
    }
  },
  methods: {
    gotoRecord() {
      if (!this.hasToken()) {
        this.requireLogin()
        return
      }
      this.$jumpTo('/recordOrder')
    },
    hasToken() {
      return !!safeGetStorageItem(getLocalStorage(), 'token')
    },
    requireLogin() {
      this.showPopup = true
      if (this.$bus) this.$bus.$emit('openLogin')
      if (this.$toast) {
        this.$toast({
          message: CROWDFUNDING_LOGIN_MESSAGE,
          icon: 'cross'
        })
      }
    },
    failMessage(res, fallback) {
      const response = this.failureResponse(res)
      if (isNeedLogin(response)) return CROWDFUNDING_LOGIN_MESSAGE
      if (this.hasCrowdfundingUnavailableMarker(response)) return this.crowdfundingUnavailableMessage(response, fallback)
      const message = this.rawFailureMessage(response, fallback || CROWDFUNDING_UNAVAILABLE_MESSAGE)
      return this.localizeGenericFailureMessage(message, fallback)
    },
    rawFailureMessage(res, fallback) {
      if (typeof responseFailMessage === 'function') return responseFailMessage(res, fallback)
      const response = this.failureResponse(res)
      if (response && typeof response === 'object') {
        return response.message ||
          response.msg ||
          response.errorMessage ||
          response.errorMsg ||
          response.reason ||
          fallback
      }
      return fallback
    },
    hasCrowdfundingUnavailableMarker(res) {
      return (typeof hasUnavailableMarker === 'function' && hasUnavailableMarker(res)) ||
        this.hasLocalCrowdfundingUnavailableMarker(res)
    },
    hasLocalCrowdfundingUnavailableMarker(res) {
      const markerText = JSON.stringify(res || {}).toLowerCase()
      return Boolean(markerText) && (
        markerText.includes('readonly') ||
        markerText.includes('read_only') ||
        markerText.includes('read only') ||
        markerText.includes('read-only') ||
        markerText.includes('routeunavailable') ||
        markerText.includes('route_unavailable') ||
        markerText.includes('route unavailable') ||
        markerText.includes('route-unavailable') ||
        markerText.includes('readunavailable') ||
        markerText.includes('read_unavailable') ||
        markerText.includes('read unavailable') ||
        markerText.includes('read-unavailable') ||
        markerText.includes('readblocked') ||
        markerText.includes('read_blocked') ||
        markerText.includes('read blocked') ||
        markerText.includes('read-blocked') ||
        markerText.includes('readfailure') ||
        markerText.includes('read_failure') ||
        markerText.includes('read failure') ||
        markerText.includes('read-failure') ||
        markerText.includes('技术错误') ||
        markerText.includes('技术异常') ||
        markerText.includes('technicalmarker') ||
        markerText.includes('technical_marker') ||
        markerText.includes('technical error') ||
        markerText.includes('technical_error') ||
        markerText.includes('technical exception') ||
        markerText.includes('technical_exception') ||
        markerText.includes('backendfailure') ||
        markerText.includes('backend_failure')
      )
    },
    failureResponse(error) {
      if (!error || typeof error !== 'object') return error
      return error.response && (error.response.data || error.response.body) ||
        error.data ||
        error.body ||
        error
    },
    crowdfundingUnavailableMessage(res, fallback) {
      const markerText = JSON.stringify(res || {}).toLowerCase()
      if (markerText.includes('need_login') || isNeedLogin(res)) return CROWDFUNDING_LOGIN_MESSAGE
      if (
        markerText.includes('readonly') ||
        markerText.includes('read_only') ||
        markerText.includes('read only') ||
        markerText.includes('read-only')
      ) return CROWDFUNDING_READONLY_MESSAGE
      if (
        markerText.includes('blocked') ||
        markerText.includes('notconnected') ||
        markerText.includes('not_connected') ||
        markerText.includes('not connected') ||
        markerText.includes('routeunavailable') ||
        markerText.includes('route_unavailable') ||
        markerText.includes('route unavailable') ||
        markerText.includes('route-unavailable') ||
        markerText.includes('write')
      ) return safeCrowdfundingFallback(fallback, CROWDFUNDING_BLOCKED_MESSAGE)
      if (
        markerText.includes('readfailure') ||
        markerText.includes('read_failure') ||
        markerText.includes('readunavailable') ||
        markerText.includes('read_unavailable') ||
        markerText.includes('read unavailable') ||
        markerText.includes('read-unavailable') ||
        markerText.includes('dataunavailable') ||
        markerText.includes('data_unavailable') ||
        markerText.includes('fallback') ||
        markerText.includes('rejected') ||
        markerText.includes('技术错误') ||
        markerText.includes('技术异常') ||
        markerText.includes('technicalmarker') ||
        markerText.includes('technical_marker') ||
        markerText.includes('technical error') ||
        markerText.includes('technical_error') ||
        markerText.includes('technical exception') ||
        markerText.includes('technical_exception') ||
        markerText.includes('backendfailure') ||
        markerText.includes('backend_failure')
      ) return safeCrowdfundingFallback(fallback, CROWDFUNDING_UNAVAILABLE_MESSAGE)
      return this.localizeGenericFailureMessage(this.rawFailureMessage(res, fallback || CROWDFUNDING_UNAVAILABLE_MESSAGE), fallback)
    },
    localizeGenericFailureMessage(message, fallback) {
      const text = String(message || '')
      if (!text || text === 'Request failed' || isTechnicalFailureMessage(text)) {
        return safeCrowdfundingFallback(fallback, CROWDFUNDING_UNAVAILABLE_MESSAGE)
      }
      if (/please log in/i.test(text)) return CROWDFUNDING_LOGIN_MESSAGE
      if (/read.?only/i.test(text)) return CROWDFUNDING_READONLY_MESSAGE
      if (/blocked|unsupported|unavailable/i.test(text)) return safeCrowdfundingFallback(fallback, CROWDFUNDING_BLOCKED_MESSAGE)
      return text
    },
    safeNumber(value, fallback = 0) {
      const n = Number(value)
      return Number.isFinite(n) ? n : fallback
    },
    firstValue(...values) {
      return values.find(value => value !== undefined && value !== null && value !== '')
    },
    isCrowdfundingServerProvenEmptyRead(res) {
      return typeof hasServerProvenEmptyRead === 'function' && hasServerProvenEmptyRead(res)
    },
    isCrowdfundingRecordReadOk(res) {
      return this.isCrowdfundingServerProvenEmptyRead(res) ||
        (isOkResponse(res) && !this.hasCrowdfundingUnavailableMarker(res))
    },
    normalizeRecordList(content) {
      const list = content && (
        content.myRecordList ||
        content.recordList ||
        content.list ||
        content.records ||
        content.items
      )
      return Array.isArray(list)
        ? list.map(item => ({
          drawDate: item.drawDate || item.createTime || item.createdAt || item.date || '',
          bonusSum: this.safeNumber(this.firstValue(item.bonusSum, item.amount, item.rewardAmount, item.bonus))
        }))
        : []
    },
    formatRecordDate(date) {
      if (!date) return '--'
      const text = this.$dayjs(date).format('YYYY-MM-DD')
      if (!text || text === 'Invalid Date') return '--'
      return `${text.slice(8, 10)}/${text.slice(5, 7)}/${text.slice(0, 4)}`
    },
    isRouletteSuccess(res) {
      return rewardRouletteSuccess(res) && hasRewardIssueProof(res) && !this.hasCrowdfundingUnavailableMarker(res)
    },
    resolvePrizeIndex(content) {
      const rawIndex = content && this.firstValue(
        content.prizeIndex,
        content.targetIndex,
        content.awardIndex,
        content.index,
        content.prizeNo,
        content.position
      )
      const index = Number(rawIndex)
      if (Number.isFinite(index) && index >= 0) {
        return Math.floor(index) % this.prizeCount
      }
      return 0
    },
    async GetLuckyRouletteRecord() {
      try {
        const data = await GetLuckyRouletteRecord({})
        if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (this.isCrowdfundingRecordReadOk(data)) {
          this.myRecordList = this.normalizeRecordList(responseContent(data))
        } else if (data) {
          this.$toast({
            message: this.failMessage(data),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: this.failMessage(e, CROWDFUNDING_UNAVAILABLE_MESSAGE),
          icon: 'cross'
        })
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    // 新增：倒计时核心方法
    startCountdown() {
      // 获取后一天早上7点的时间戳
      const targetDate = new Date()
      targetDate.setDate(targetDate.getDate() + 1) // 后一天
      targetDate.setHours(7, 0, 0, 0) // 设置为早上7点

      // 每秒更新一次倒计时
      this.timer2 = setInterval(() => {
        const now = new Date()
        const timeLeft = targetDate - now // 剩余时间（毫秒）

        if (timeLeft > 0) {
          // 计算时分秒
          const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24)
          const minutes = Math.floor((timeLeft / (1000 * 60)) % 60)
          const seconds = Math.floor((timeLeft / 1000) % 60)

          // 格式化为两位数
          this.countdown = `${String(hours).padStart(2, '0')}:${String(
            minutes
          ).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        } else {
          // 如果时间已过，停止倒计时
          clearInterval(this.timer2)
          this.countdown = '00:00:00'
        }
      }, 1000) // 每秒更新一次
    },
    // 切换背景图片的方法
    switchBackgroundImage() {
      // 切换到下一张图片，循环切换
      this.currentBgIndex = (this.currentBgIndex + 1) % this.bgImages.length
    },
    // 大转盘相关方法
    toggleRotation() {
      this.GetLuckyRoulette()
    },
    shareContent() {
      const storage = getLocalStorage()
      const shareUrl = buildShareUrl(storage)
      if (!shareUrl) {
        safeToast(this, {
          message: SHARE_FAILED_MESSAGE,
          icon: 'cross'
        })
        return
      }
      if (canUseNativeShare()) {
        const nativeShare = getNativeShare()
        if (!nativeShare) {
          safeToast(this, {
            message: SHARE_UNSUPPORTED_MESSAGE,
            icon: 'cross'
          })
          return
        }
        const shareResult = callNativeShare(nativeShare, {
          title: 'VUKAVI',
          text: 'VUKAVI',
          url: shareUrl
        })
        if (shareResult && typeof shareResult.catch === 'function') {
          shareResult.catch(error => {
            const message = shareFailureMessage(error)
            if (message) {
              safeToast(this, {
                message,
                icon: 'cross'
              })
            }
          })
        }
      } else {
        safeToast(this, {
          message: SHARE_UNSUPPORTED_MESSAGE,
          icon: 'cross'
        })
      }
    },
    async GetLuckyRoulette() {
      try {
        const data = await GetLuckyRoulette({})
        if (isNeedLogin(data)) {
          this.requireLogin()
        } else if (isOkResponse(data) && !this.hasCrowdfundingUnavailableMarker(data) && Object.keys(responseContent(data)).length) {
          const content = responseContent(data)
          this.bonusSum = this.safeNumber(content.bonusSum)
          this.drawCount = this.safeNumber(content.drawCount)
          this.rouletteAvailable = true
        } else if (data) {
          this.rouletteAvailable = false
          this.$toast({
            message: this.failMessage(data, this.$lang.feature_unavailable || CROWDFUNDING_UNAVAILABLE_MESSAGE),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.rouletteAvailable = false
        this.$toast({
          message: this.failMessage(e, this.$lang.LuckyRoulette_unavailable || CROWDFUNDING_BLOCKED_MESSAGE),
          icon: 'cross'
        })
      }
    },
    async spinRoulette() {
      try {
        const data = await LuckyRoulette({})
        if (isNeedLogin(data)) {
          this.requireLogin()
          return null
        }
        if (this.isRouletteSuccess(data)) {
          const content = responseContent(data)
          this.getBonusSum = this.safeNumber(content.bonusSum)
          this.drawCount = this.safeNumber(content.drawCount, Math.max(this.drawCount - 1, 0))
          return this.resolvePrizeIndex(content)
        }
        this.$toast({
          message: this.failMessage(data, this.$lang.feature_unavailable || CROWDFUNDING_UNAVAILABLE_MESSAGE),
          icon: 'cross'
        })
      } catch (e) {
        this.$toast({
          message: this.failMessage(e, CROWDFUNDING_BLOCKED_MESSAGE),
          icon: 'cross'
        })
      }
      return null
    },
    // 开始旋转
    async startRotation() {
      if (!this.hasToken()) {
        this.requireLogin()
        return
      }
      if (!this.rouletteAvailable) {
        this.$toast({
          message: this.$lang.LuckyRoulette_unavailable || this.$lang.feature_unavailable || CROWDFUNDING_UNAVAILABLE_MESSAGE,
          icon: 'cross'
        })
        return
      }
      if (this.drawCount === 0) {
        this.$jumpTo('/Alliance')
        return
      }

      // if (this.drawCount === 0) {
      //   this.isShareBtn = true
      // } else {
      //   this.isShareBtn = false
      // }

      if (this.isSpinning) return
      this.isSpinning = true

      try {
        if (this.drawCount > 0) {
          const targetIndex = await this.spinRoulette()
          if (targetIndex == null) {
            this.isSpinning = false
            return
          }
          this.rotateTurntable(targetIndex)
        }
      } catch (error) {
        this.$toast({
          message: this.failMessage(error, CROWDFUNDING_BLOCKED_MESSAGE),
          icon: 'cross'
        })
        this.isSpinning = false
      }
    },
    // 执行转盘旋转
    rotateTurntable(targetIndex) {
      // 计算每个奖品区块角度
      const sectorAngle = 360 / this.prizeCount

      // 目标角度 = 完整圈数 + 目标位置角度 - 校正偏差
      const fullCircles = 3 * 360 // 至少旋转3圈
      const targetAngle = fullCircles + targetIndex * sectorAngle

      // 计算最终角度（注意要基于当前角度继续旋转）
      this.currentAngle += fullCircles - (this.currentAngle % 360) + targetAngle
      // 动画结束后恢复状态
      setTimeout(() => {
        this.isSpinning = false
        this.GetLuckyRoulette()
        this.GetLuckyRouletteRecord()
        // 移除了中奖弹窗相关代码
      }, 4500) // 需要与CSS动画时间匹配
    }
  },
  mounted() {
    // 组件挂载时获取转盘数据
    if (this.hasToken()) {
      this.GetLuckyRoulette()
      this.GetLuckyRouletteRecord()
    }

    // 启动背景图片切换定时器，修改为500毫秒切换一次
    this.bgSwitchTimer = setInterval(() => {
      this.switchBackgroundImage()
    }, 500)

    // 新增：启动倒计时
    this.startCountdown()
  },
  beforeDestroy() {
    // 组件卸载时清除定时器，防止内存泄漏
    if (this.bgSwitchTimer) {
      clearInterval(this.bgSwitchTimer)
    }
    // 新增：清除倒计时定时器
    if (this.timer2) {
      clearInterval(this.timer2)
    }
  }
}
</script>

<style lang="less" scoped>
.scroll_ranking_sroll {
  background: #191a25;
  height: 150px;
  width: 94%;
  margin: 0 auto;
  border-radius: 10px;
  overflow: auto;
  padding: 10px 0;
}
.scroll_ranking {
  background: #212331;
  color: #bbc4dd;
  padding-bottom: 10px;
}
.scroll_ranking_title {
  padding: 5px 30px 10px;
  border-top: 1px solid #272837;
}
.scroll_invites {
  background: url(../../assets/img/otgame/pdd_di.png) no-repeat;
  height: 45px;
  background-size: 100% 100%;
}
// 关键修改：添加position和z-index，确保标题栏层级最高
.crowd-title {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #232433;
  padding: 0 16px;
  position: sticky; // 必须添加定位，让z-index生效
  z-index: 999999; // 保持最高层级，避免被遮挡
  top: 0;
}

// 旋转背景图样式 - 保留原动画，作为底层背景
.crowd_rotate_img {
  margin-top: 50px;
  width: 100%;
  position: relative;
  z-index: 1; /* 层级低于转盘 */
  img {
    animation: rotate 10s linear infinite;
    transform-origin: center center;
  }
}

// 大转盘外层容器 - 调整位置，避免覆盖标题栏
.turntable-wrapper {
  position: relative;
  width: 100%;
  z-index: 2; /* 保持层级高于背景图 */
  display: flex;
  justify-content: center;
  align-items: center;
  // padding-top: 40px; /* 保留顶部内边距，避免和标题栏太近 */
  margin-top: -546px;
}

// 大转盘样式
.lettey-bg {
  background: url(../../assets/img/lucky_jackpot/zhuanpankuang2.png) no-repeat;
  background-size: 100% 100%;
  height: 525px;
  padding-top: 172px;
  margin: 30px auto 0;
  width: 100%;
  max-width: 390px;
  position: relative;
}

.container {
  position: relative;
  width: 266px;
  height: 265px;
  margin: 0 auto;
}

.turntable {
  margin-top: -277px;
  width: 100%;
  height: 98%;
  border-radius: 50%;
  background: url('../../assets/img/lucky_jackpot/zhuanpan2.png') no-repeat
    center/cover;
  transition: transform 4.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  margin-left: 1px;
}

.pointer {
  position: absolute;
  top: 29%;
  left: 34%;
  width: 95px;
  height: 105px;
  background: url('../../assets/img/lucky_jackpot/anniu2.png') no-repeat;
  background-size: 100% 100%;
  z-index: 3; /* 按钮层级最高 */
  border: none;
  color: white;
  padding: 12px 10px 0 10px;
  cursor: pointer;
}

.btn-share {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 13px;
  padding: 10px;
  font-size: var(--vk-fs-xs);
  top: 150px;
  line-height: 15px;
  z-index: 3;
}

.triangle {
  top: 137px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: 3;
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid rgba(0, 0, 0, 0.5);
}

.btn-share--b {
  background: #dd2647;
  border-radius: 8px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  cursor: pointer;
}
.turntable-bg-s {
  height: 295px;
  width: 77%;
  margin: -16px auto 0;
  background-size: 100% 100% !important;
  transition: background 0.3s ease;
}

// 定义旋转关键帧
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
